import { Link, NavLink, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
//import { BsTwitter, BsLinkedin, BsFacebook, BsInstagram, BsArrowRight } from "react-icons/bs";
import * as BsIcons from "react-icons/bs";
// import headerWatch from "../../Assets/header-watch.gif";
import NO_IMAGE from "../../Assets/no_img.jpg";
import "./HomeStyle.css";
import { ProductContext } from "../../Contexts/ProductContext";
import { IMAGE_URL, ONLINELISTOFFERDISPLAY, SUCCESS } from "../../Utils/constant";
import { NewlyUploadedProduct } from "../ProductCard/NewlyUploadedProduct.jsx";
import { isEmpty, printDebugLog } from "../../Utils/utils.js";
import { CountdownTimer } from "../global/CountdownTimer.jsx";
import { TextMarquee } from "../global/TextMarquee.jsx";
import { motion } from "framer-motion";
import { getData } from "../../Utils/apiController.js";

const Home = () => {
  const { productState, filtersDispatch, getCategories, getNewArrivalProducts, getSocialConfigs, getUpcomingTime } = useContext(ProductContext);
  const navigate = useNavigate();
  //{ day: 0, hour: 0, minute: 0, second: 0 }
  const [timeState, setTimeState] = useState(null);
  const [messages, setMessages] = useState(null);
  const [socialLinks, setSocialLinks] = useState([]);

  const handleOfferMessages = async () => {
    const res = await getSocialConfigs(ONLINELISTOFFERDISPLAY);
    printDebugLog("handleOfferMessages", res);
    setMessages(res ?? null);
  }

  const handleOfferTimeRelease = async () => {
    const res = await getUpcomingTime();
    printDebugLog("handleOfferTimeRelease", res);
    if (res !== null && res.status === SUCCESS && res.data) {
      setTimeState(res.data);
    } else {
      setTimeState(null);
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getCategories();
    getNewArrivalProducts();
    handleOfferMessages();
    handleOfferTimeRelease();

    getData({
      url: "social.json",
      onResponse: (success, data) => {
        if (success) {
          setSocialLinks(data.socialLinks ?? []);
        } else {
          setSocialLinks([]);
        }
      },
    });
  }, []);


  return (
    <div>
      <header>
        {/* <div className="header-img">
          <img src={headerWatch} alt="watch" />
        </div> */}
        <div className="header-body">
          <h2>Discover Our Latest Watch Collection</h2>
          <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
            Explore our range of premium watches designed to add sophistication to your style.
          </p>
          <NavLink to="/products">
            <button
            >
              Explore Watches
            </button>
          </NavLink>
        </div>

      </header>
      <section className="category-section">
        <motion.div
          className="category-head"
          animate={{ y: [0, -2, 0] }}
          whileHover={{ rotate: -0.5, scale: 1.02 }}
          transition={{
            y: { duration: 1.8, repeat: Infinity, ease: "easeInOut" },
            rotate: { type: "spring", stiffness: 300, damping: 20 },
            scale: { type: "spring", stiffness: 300, damping: 20 }
          }}
        >
          <TextMarquee items={messages} />
        </motion.div>

        <motion.div className="category-head" animate={{ y: [0, -2, 0] }}
          whileHover={{ rotate: -2, scale: 1.02 }}
          transition={{
            y: { duration: 1.8, repeat: Infinity, ease: "easeInOut" },
            rotate: { type: "spring", stiffness: 300, damping: 20 },
            scale: { type: "spring", stiffness: 300, damping: 20 }
          }}>
          {timeState && (
            <CountdownTimer
              days={timeState.days}
              hours={timeState.hours}
              minutes={timeState.minutes}
              seconds={timeState.seconds}
            />
          )}
        </motion.div>

        <div className="category-head">
          <h1>Feature Watches</h1>
        </div>
        <div className="category-container">
          {productState.categories.map(
            (singleCateogory) => (
              <motion.div animate={{ y: [0, -8, 0] }}
                whileHover={{ rotate: -2, scale: 1.02 }}
                transition={{
                  y: { duration: 1.8, repeat: Infinity, ease: "easeInOut" },
                  rotate: { type: "spring", stiffness: 300, damping: 20 },
                  scale: { type: "spring", stiffness: 300, damping: 20 }
                }}
                key={singleCateogory._id}
                className="category-card"
                onClick={() => {
                  filtersDispatch({
                    type: "clearAndSetCategory",
                    payload: singleCateogory,
                  });
                  navigate("/products", { state: { catgId: singleCateogory } });
                }}
              >
                <div className="category-image">
                  {
                    isEmpty(singleCateogory.image) ? (
                      <img src={NO_IMAGE} alt={singleCateogory.catgName} />
                    ) : (
                      <img src={`${IMAGE_URL}${singleCateogory.image}`} alt={singleCateogory.catgName} />
                    )
                  }
                </div>
                <div className="category-body">
                  <h1>{singleCateogory.catgName}</h1>
                  <h4 style={{ color: "grey" }}>{singleCateogory.inventoryType}</h4>
                  <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{singleCateogory.subCatgName}</p>
                  <button>
                    see Collection <BsIcons.BsArrowRight />
                  </button>
                </div>
              </motion.div>
            )
          )}
        </div>
      </section>
      {
        (productState.newArrivalProducts && productState.newArrivalProducts.length > 0) &&
        <section className="category-section">
          <div className="category-head">
            <h1>Newly Uploaded</h1>
          </div>
          <div className="category-container">
            {
              productState.newArrivalProducts.map((product) => (
                <NewlyUploadedProduct key={product.prdId} product={product} />
              ))
            }
          </div>
        </section>
      }
      <footer>
        <div className="footer-container">
          <div className="footer-policy">
            <Link to="/terms-and-condition" state={{ url: "terms" }}>Terms & Condition</Link>

            <Link to="/shipping-policy" state={{ url: "shipping" }}>Shipping Policy</Link>

            <Link to="/cancellation-policy" state={{ url: "cancellation" }}>Cancellation Policy</Link>

            <Link to="/privacy-policy" state={{ url: "privacy" }}>Privacy Policy</Link>
          </div>
          <div className="footer-url" rel="noopener">
            {socialLinks.map((item, index) => {
              const Icon = BsIcons[item.icon];

              if (!Icon) return null;
              if (isEmpty(item.href)) return null;

              return (
                <a
                  key={index}
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={item.label}
                >
                  <Icon size={22} />
                </a>
              );
            })}
          </div>
          <p className="footer-head">
            Copyright &#169; <Link to="https://www.snpnextgen.com/">SNP A2Z Solutions</Link>
            {" " + new Date().getFullYear()}
            {". An ISO 9001:2015 Certified Company"}.
          </p>
        </div>
      </footer>
    </div>
  );
};
export { Home };
